// TODO: FHS - Update FHS Icon
import React from 'react';

import { Icon } from '@fhs-legacy/universal-components';

export default () => <Icon variant="plkGiftCard" />;
